var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9695 25.9125L24.3701 8.35312C24.327 7.86937 23.922 7.5 23.4364 7.5H20.6239V5.625C20.6239 4.1175 20.0389 2.70375 18.9795 1.64437C17.937 0.6 16.4858 0 14.9989 0C11.8976 0 9.37389 2.52375 9.37389 5.625V7.5H6.56139C6.07577 7.5 5.67077 7.86937 5.62764 8.35312L4.03202 25.9106C3.93639 26.9587 4.28889 28.0031 4.99764 28.7794C5.70639 29.5556 6.71514 30 7.76702 30H22.2326C23.2826 30 24.2914 29.5556 25.0001 28.7812C25.7108 28.005 26.0614 26.9587 25.9695 25.9125ZM18.7489 7.5H11.2489V5.625C11.2489 3.55687 12.9308 1.875 14.9989 1.875C15.9926 1.875 16.9601 2.2725 17.6539 2.96812C18.3608 3.675 18.7489 4.61812 18.7489 5.625V7.5Z",
    fill: "#FFBB38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.b9ad935a0c2f78b1e8ad67f41701c053.svg";
export { ForwardRef as ReactComponent };